import React from 'react'
import { SubTitle } from '../../common/form-components/label/Label'
import FulesPriceTable from './FuelsPriceTable'

const LastNotifiedPrices = ({ latestPrices }) => {
  return (
    <>
      <SubTitle id="last.notified.prices" />
      <FulesPriceTable prices={latestPrices} />
    </>
  )
}

export default LastNotifiedPrices
